export function mapUnifiedBuildStatus(status, conclusion) {
  if (status === "in_progress" || status === "queued") return "in_progress";
  if (conclusion === "success") return "succeeded";
  if (conclusion === "failure") return "failed";
  if (conclusion === "cancelled") return "stopped";
  if (conclusion === "timed_out") return "failed";
  return status || "stopped";
}

export function resolveBuildDurationSeconds(build) {
  if (typeof build?.durationSeconds === "number" && build.durationSeconds > 0) {
    return build.durationSeconds;
  }

  if (build?.completedAt && build?.startedAt) {
    const durationSeconds = Math.round(
      (new Date(build.completedAt) - new Date(build.startedAt)) / 1000
    );
    return durationSeconds > 0 ? durationSeconds : 0;
  }

  return 0;
}

function normalizeBuildForProgress(build) {
  return {
    buildStatus: build?.buildStatus ?? build?.status ?? null,
    projectName: build?.projectName ?? null,
    startedAt: build?.startedAt ?? null,
    durationSeconds: resolveBuildDurationSeconds(build),
  };
}

export function estimateBuildProgress(build, allBuilds = []) {
  const targetBuild = normalizeBuildForProgress(build);

  if (targetBuild.buildStatus !== "in_progress" || !targetBuild.startedAt) {
    return null;
  }

  const completedBuilds = allBuilds
    .map(normalizeBuildForProgress)
    .filter(
      (candidate) =>
        candidate.projectName === targetBuild.projectName &&
        candidate.buildStatus !== "in_progress" &&
        candidate.durationSeconds > 0
    );

  if (completedBuilds.length === 0) {
    return null;
  }

  const avgDuration =
    completedBuilds.reduce(
      (total, candidate) => total + candidate.durationSeconds,
      0
    ) / completedBuilds.length;

  if (avgDuration <= 0) {
    return null;
  }

  const elapsedSeconds =
    (Date.now() - new Date(targetBuild.startedAt).getTime()) / 1000;
  const progress = Math.min(
    99,
    Math.round((elapsedSeconds / avgDuration) * 100)
  );

  return Math.max(0, progress);
}
